export enum InboundConnectionStatus {
  Connected = 'Connected',
  Disconnected = 'Disconnected',
}
